<div class="account-filter-body">
  <account-search [isAccountFilter]="true" [selectedValue]="currentValue" (selected)="accountSelected($event)">
  </account-search>
</div>
